import { FeatureDisabled } from 'Shared/backend/features/FeatureDisabled';
import { useVenue } from 'Shared/VenueProvider';
import { Show } from 'solid-js';
import { RouteSectionProps } from '@solidjs/router';


export function MenusGate(P:RouteSectionProps)
{
	return (
		<Show when={useVenue().settings.general.enableMenus} fallback={<FeatureDisabled feature='Menus' />}>
			{P.children}
		</Show>
	);
}

export function SpecialsGate(P:RouteSectionProps)
{
	return (
		<Show when={useVenue().settings.general.enableSpecials} fallback={<FeatureDisabled feature='Specials' />}>
			{P.children}
		</Show>
	);
}

export function EventsGate(P:RouteSectionProps)
{
	return (
		<Show when={useVenue().settings.general.enableEvents} fallback={<FeatureDisabled feature='Events' />}>
			{P.children}
		</Show>
	);
}

export function StaffResourcesGate(P:RouteSectionProps)
{
	return (
		<Show when={useVenue().settings.general.enableStaffResources} fallback={<FeatureDisabled feature='Staff resources' />}>
			{P.children}
		</Show>
	);
}
